import React from 'react';
import PropTypes from 'prop-types';

const CompanyDelete = ({ t = (key) => key, canDelete, handleClick = () => {} }) => {
  return canDelete ? (
    <button className="close delete" onClick={handleClick}>
      <i className="fa fa-times-circle" />
    </button>
  ) : null;
};

CompanyDelete.propTypes = {
  t: PropTypes.func,
  canDelete: PropTypes.bool.isRequired,
};

export default CompanyDelete;



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/components/CompanyDelete.js